import React from "react";
import { Trace } from "../../store/tracing/types";
import { formatDate, shouldRecordTraces, setShouldRecordTraces } from "../../shared/utilities";
import { FormControlLabel, Switch } from "../../shared/components";
import { EditableValueField } from "./shared";

function renderTrace(trace: Trace, index: number) {
    return (
        <tr key={`trace-${index}`}>
            <td>{formatDate(trace.timestamp, "HH:mm:ss.SSS")}</td>
            <td>{trace.event.kind}</td>
            <td>{trace.event.name}</td>
            <td><EditableValueField value={trace.event["oldValue"]} /></td>
            <td><EditableValueField value={trace.event["newValue"] ?? trace.event["error"]} /></td>
        </tr>
    );
}

function Traces() {
    const [_refresh, setRefresh] = React.useState(0);
    const [recordTraces, setRecordTraces] = React.useState(shouldRecordTraces());
    React.useEffect(() => {
        if (!recordTraces) return;

        // While recording traces, poll + update the list every 2 seconds...
        const traceRefreshInterval = setInterval(() => setRefresh(r => r + 1), 2000);
        return () => clearInterval(traceRefreshInterval);
    }, [recordTraces]);

    const onRecordTracesChanged = React.useCallback((_event, newValue) => {
        setShouldRecordTraces(newValue);
        setRecordTraces(newValue);
    }, [recordTraces]);

    return (
        <div className="traces-layout">
            <FormControlLabel
                className="plush"
                control={<Switch color="primary" checked={recordTraces} onChange={onRecordTracesChanged} />}
                label="Record Events : " />
            
            <div className="table-container traces">
                <table className="table bordered striped">
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Event Type</th>
                            <th>Name</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(window["__TRACE_EVENTS__"] ?? [])?.map(renderTrace)}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default React.memo(Traces);